import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";
import React from "react";
import ServicesCards from "../../components/ServicesCards";

import bore from "../../images/services/bore1.png";
import elevator from "../../images/services/elevator1.png";
import greenrenewable from "../../images/services/greenrenewable1.png";
import fabric from "../../images/services/fabric1.png";
import Navbar from "../../components/NavbarServices";

import Footer from "../../sections/S8_Footer";
import S7 from "../../sections/S7_Message";
const Wrapper = styled.div`
  padding-bottom: 100px;
  padding-top: 100px;
`;
const Wrapped = styled.div`
  padding-top: 60px;
  @media (max-width: 599px) {
    padding-top: 20px;
  }
`;
const index = () => {
  return (
    <div>
      <Navbar>Services</Navbar>
      <Container>
        <Wrapper>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <a
                style={{ textDecoration: "none", color: "black" }}
                href="/services/fabrication"
              >
                <ServicesCards
                  heading="Expansion by 
                  Pre-Fabricated Structure"
                  text="Whether it is a house or a farmhouse, build rooms and living spaces that are open, comfortable and cozy.
                  Our designed architecture structure is light in weight, beautiful in appearance, unique in durability and incomparable. Whether you need a living space or a extra storage, we will tailor the structure to your needs."
                  CardImg={fabric}
                />
              </a>
            </Grid>
            <Grid item xs={12} md={6}>
              <a
                style={{ textDecoration: "none", color: "black" }}
                href="/services/bore"
              >
                <ServicesCards
                  heading="Re-Charge Bore-Well"
                  text="Recharge home water bore or tube well with a natural source of rain. Get rid of the hassle of drying bore wells after a while and adopt a sustainable source of natural groundwater. Do it all in a very safe and transparent way at a low cost. Be completely safe from any kind of harmful health effects. "
                  CardImg={bore}
                />
              </a>
            </Grid>
          </Grid>
          <Wrapped></Wrapped>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <a
                style={{ textDecoration: "none", color: "black" }}
                href="/services/solar"
              >
                <ServicesCards
                  heading="Green Renewable Energy"
                  text="Along with residential construction, solar power supply to the house is also provided. Lifelong freedom from WAPDA bills and 24/7 constant availability of electricity at home.

                  Solar energy: on-grid system, off-grid system, battery backup storage and UPS, ie exactly what you need."
                  CardImg={greenrenewable}
                />
              </a>
            </Grid>
            <Grid item xs={12} md={6}>
              <a
                style={{ textDecoration: "none", color: "black" }}
                href="/services/elevator"
              >
                <ServicesCards
                  heading="Home Elevator/lift"
                  text="It is now very easy to take the elderly, sick people or women and children in the house and bring them back to the roof or upstairs of the house easily and safely. Our partner GSM Elevator Company is ready to meet your need at the most reasonable cost. More than twenty years of experience in elevator and elevator system installation, it will provide this facility at your home in a highly professional and experienced manner.
                  "
                  CardImg={elevator}
                />
              </a>
            </Grid>
          </Grid>
        </Wrapper>
      </Container>
      <S7 />
      <Footer />
    </div>
  );
};

export default index;
